import { CabinGradeType, CruiseShipDeckID } from "@cruisen/contract"
import { FilterRange } from "../../utils/data"
import { _t } from "@cruisen/i18n"

export type AvailableModals =
  | "cabinSelection"
  | "decksModal"
  | "cabinsFilteringModal"
  | "cabinDetails"
  | "bookedRoom"

export type SelectedCabinFilters = {
  priceFilters: FilterRange
  cabinTypes: CabinGradeType[]
  filteredDeckIds: CruiseShipDeckID[]
}

export const getAllCabinTypes = (): { id: CabinGradeType; label: string }[] => [
  {
    id: "inside",
    label: _t("cabinTypesDescriptions.inside"),
  },
  {
    id: "outside",
    label: _t("cabinTypesDescriptions.outside"),
  },
  {
    id: "balcony",
    label: _t("cabinTypesDescriptions.balcony"),
  },
  {
    id: "suite",
    label: _t("cabinTypesDescriptions.suite"),
  },
]
